//单点登录使用的批量办理（我方app 专用）
import workflowFormRouter from '../router/workflowFormRouter'
export default
    {
        path: "/list",
        component: () => import('../view/processlistview/mainIndex.vue'),
        children: [
            
            {
                path: "mainListView",
                component: () => import('../view/processlistview/mainBatch.vue'),
                children:[
                    {
                        path: "BatchHandle",
                        name: "BatchHandle",
                        component: () => import('../view/processlistview/BatchHandle.vue'),
                        props: (route) => (
                            {
                                token:route.query.token,
                                koaToken:route.query.koaToken,
                                userId:route.query.userId,
                                deviceType:route.query.deviceType,
                                deviceName:route.query.deviceName,
                                st:route.query.st,
                                newVersion:route.query.newVersion,
                                secondLoginType:route.query.secondLoginType,
                                secondAssessToken:route.query.secondAssessToken,
                                deviceId:route.query.deviceId,
                                
                            }
                        )
                    }
                ]
            },
            
            
        ]

    }



// WEBPACK FOOTER //
// ./src/router/batchRouter.js